;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export enum WorkspaceUserStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
	SUSPENDED = "SUSPENDED",
	PENDING = "PENDING",
}

export enum ViewStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}

export enum InvitationStatus {
	PENDING = "PENDING",
	ACCEPTED = "ACCEPTED",
	EXPIRED = "EXPIRED",
	FAILED = "FAILED",
}

export interface View {
	id: string;
	name: string;
	description?: string;
	status: ViewStatus;
}

export interface Workspace {
	id: string;
	name: string;
	role: string;
	organizationId: string;
	views: View[];
	activeViews: View[];
	permissions: {
		[key: string]: {
			canView: boolean;
			canCreate: boolean;
			canEdit: boolean;
			canDelete: boolean;
		};
	};
	status: WorkspaceUserStatus;
	setupComplete: boolean;
	createdAt: string;
	updatedAt: string;
}

export interface WorkspaceMember {
	id: string;
	userId: string;
	workspaceId: string;
	role: "ADMIN" | "USER";
	createdAt: Date;
	updatedAt: Date;
}

export interface WorkspaceUser {
	id: string;
	role: string;
	userId: string;
	workspaceId: string;
	createdAt: Date;
	updatedAt: Date;
	permissions: WorkspacePermission[];
}

export interface WorkspacePermission {
	id: string;
	resource: string;
	canView: boolean;
	canCreate: boolean;
	canEdit: boolean;
	canDelete: boolean;
	workspaceUserId: string;
	createdAt: Date;
	updatedAt: Date;
}

export interface WorkspaceInvitation {
	id: string;
	email: string;
	workspaceId: string;
	organizationId: string;
	role: string;
	status: InvitationStatus;
	invitedBy: {
		id: string;
		firstName: string;
		lastName: string;
		email: string;
	};
	invitedById: string;
	permissions: {
		resource: string;
		canView: boolean;
		canCreate: boolean;
		canEdit: boolean;
		canDelete: boolean;
	}[];
	expiresAt: Date;
	createdAt: Date;
	updatedAt: Date;
}
